const findMembershipBySfid = (memberships, membershipSfid) =>
  memberships.find(({ sfid }) => sfid === membershipSfid)

export default findMembershipBySfid
